<template>
  <div class="c-app flex-row align-items-center">
    <CContainer style="display: flex; justify-content: center" class="p-0">
      <div class="container-box center">
        <div class="text-left">
          <div class="card-custom-web">
            <br />

            <div class="list-grade">
              <div>
                <label class="ml-3">Resumes</label>
                <br />
                <CCard class="upload-resume">
                  <CButton style="color: #007CEF;">
                    Upload Your Resume 
                    <br /> <br />
                    <input type="file" id="file" ref="file" accept="" v-on:change="handleFileUpload()" />
                    <!-- <input type="file" id="file" ref="file" accept="image/jpeg" v-on:change="handleFileUpload()"></input> -->
                  </CButton>
                </CCard>                
              </div>
              <div style="clear: both"></div>
              </div>

          </div>
        </div>
      </div>
    </CContainer>
      <div class="bottom-center">
      <CButton color="primary" class="btn-select-blue mt-5" @click="SubmitResume()"> Submit Application</CButton>
    </div>
    <div class="header-top">My Resume</div>
    <div class="header-left">
      <img src="../../assets/img/icon/VectorLeft.svg" @click="GoBack()"/>
    </div>
    <div style="clear: both"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      user: {},
      // teacher: {},
    };
  },

  async mounted() {
    let isAuth = await this.UserAuth();

    if (isAuth) {
      this.Busy = false;
      this.GetInfoUser();
    } else {
      this.GoToLogin();
    }
  },

  methods: {
    GetInfoUser() {
      return this.$API
        .get(this.$LoginUserDetailWebs, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200) {
            this.user = response.data;
            // this.GetTeacherProfile(this.user.id);
          }
        });
    },
    
    // GetTeacherProfile() {
    //   return this.$API
    //     .get(this.$TeacherProfile + "?userId=" + this.user.id, {
    //       withCredentials: true,
    //     })
    //     .then((response) => {
    //       if (response.status == 200) {
    //         this.teacher = response.data;
    //       }
    //     });
    // },

    handleFileUpload() {
      this.file = this.$refs.file.files[0];
      console.log(this.file);
    },

    SubmitResume()
    {
      const formData = new FormData();

      // let langJson = JSON.stringify([{"LanguageId":this.LanguageId}])

      formData.append("resume", this.file);
      formData.append("teacherId", this.$route.query.teacherId);

      return this.$API
        .post(this.$UpdateTutorResume, formData, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.$dialog
              .alert("Request Sent.")
              this.GoToAllSet();
              // .then(function (dialog) {
              //   console.log("Closed");
              // });
              
          }
        })
        .catch((error) => {
          if (error.response) {
            this.Busy = false;
            this.Error = true;
            console.log(error.response.status);
          }
        });
    },

    GoToAllSet() {
      this.$router.push("BTAllSet");
    },

    GoBack() {
      this.$router.back();
    },
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Montserrat&family=Poppins&display=swap");

input {
  /* border-bottom: 2px solid #dbdbdb; */
  background: none;
  border-top: none;
  border-left: none;
  border-right: none;
  width: 90%;
}

input ::placeholder {
  color: #e0e0e0;
}

::placeholder {
  /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: #e0e0e0;
}
.c-app {
  background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
}
.custom-bg-color {
  background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
  /* Clickable/Light */

  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.05);
  border-radius: 8px;
  margin: 0px 20px;
  display: flex;
  justify-content: center;
}
body {
  font-family: "Montserrat", sans-serif;
}

.upload-resume {
  border: 1px dashed #ABABAB;
border-radius: 8px;
}
</style>